import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";
import type { BaseItem, GroupedItem } from "@/core/types";

export async function getReasoningOptions(): Promise<GroupedItem<BaseItem>[]> {
  return acuityRequestsTyped.get_reasoning_options({ context: { showLoader: false } });
}
